import { render, staticRenderFns } from "./MusicPage.vue?vue&type=template&id=9a6c0238&scoped=true&"
import script from "./MusicPage.vue?vue&type=script&lang=ts&"
export * from "./MusicPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6c0238",
  null
  
)

export default component.exports